/** Light/dark section backgrounds on the marketing home page only. */
export function HomeThemeToggle({ theme, onToggle, className = '' }) {
  const isLight = theme === 'light'
  return (
    <button
      type="button"
      className={`home-theme-toggle${className ? ` ${className}` : ''}`}
      onClick={onToggle}
      aria-pressed={isLight}
      aria-label={isLight ? 'Switch to dark mode' : 'Switch to light mode'}
      title={isLight ? 'Dark mode' : 'Light mode'}
    >
      <span className="home-theme-toggle__track" aria-hidden="true">
        <span className={`home-theme-toggle__thumb${isLight ? ' home-theme-toggle__thumb--light' : ''}`} />
      </span>
      <span className="home-theme-toggle__label">{isLight ? 'Light' : 'Dark'}</span>
    </button>
  )
}
